import { persistStateTypes } from 'a/reducers/persistStateReducer';
import * as AppSessionActions from 'a/actions/appSessionActions';

const PersistStateMiddleware = store => next => (action) => {
  // for all successful api calls, reset the session timer
  if ([
    persistStateTypes.REQUESTRESPONSE_GAMESTATE,
    persistStateTypes.POSTRESPONSE_GAMESTATE,
    persistStateTypes.REQUESTRESPONSE_GAMESTATE_ALL,
  ].includes(action.type)) {
    store.dispatch(AppSessionActions.resetSessionTimer());
  }

  let newAction;
  // pass newAction if any otherwise the existing action back to redux
  return next(newAction || action);
};

export default PersistStateMiddleware;
